<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-form ref="form" v-model="valid" >
      <v-card>
        <v-toolbar color="primary darken-1" dark>
          <v-card-title>
            <span class="">{{
              (editedIndex === -1 ? $t("add") : $t("edit")) +
              " " +
              $t("servers.server")
            }}</span>
          </v-card-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  outlined
                  hide-details
                  persistent-hint
                  v-model="editedItem.domain"
                  :rules="[rulesWithLength.required]"
                  :label="$t('servers.domain')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  outlined
                  hide-details
                  persistent-hint
                  v-model="editedItem.ip"
                  :rules="[rulesWithLength.required]"
                  :label="$t('servers.ip')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  outlined
                  hide-details
                  persistent-hint
                  type="number"
                  v-model="editedItem.max_schools"
                  :rules="[rules.required]"
                  :label="$t('servers.max_schools')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-switch
                    outlined
                    hide-details
                    persistent-hint
                    v-model="editedItem.allow_schools"
                    :label="$t('servers.allow_schools')"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                    outlined
                    hide-details
                    persistent-hint
                    type="number"
                    v-model="editedItem.comments"
                    :label="$t('servers.comments')"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            class="white--text"
            @click="save"
            :disabled="!valid || submitLoading"
            :loading="submitLoading"
            :min-width="100"
          >
            <v-icon>mdi-content-save-outline</v-icon>
            {{ $t("save") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="onClose">
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  props: [
    "onSave",
    "onClose",
    "dialog",
    "editedItem",
    "editedIndex",
    "resetValidation",
  ],
  data() {
    return {
      valid: true,
      submitLoading: false,
      rules: {
        required: (value) => !!value || this.$t("ThisFieldIsRequired"),
        length: (value) => value.length < 255 || this.$t("InvalidInput"),
      },
      rulesWithLength: {
        required: (value) =>
          (value != null && value.length < 255) ||
          this.$t("ThisFieldIsRequired"),
      },
    };
  },
  watch: {
    resetValidation() {
      this.resetForm();
    },
  },
  computed: {},
  methods: {
    resetForm() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    save() {
      this.submitLoading = true;
      var val = this.$refs.form.validate();
      if (val) {
        if (this.editedIndex > -1) {
          this.$axios
            .post(
              "servers/" + this.editedItem.id,
              this.editedItem
            )
            .then((response) => {
              if (response.data.status == "Successful") {
                this.onClose();
                this.$emit("refreshTable");
              }
            })
              .finally(() => {
                this.submitLoading = false;
              })
        } else {
          this.$axios
            .post("servers", this.editedItem)
            .then((response) => {
              if (response.data.status == "Successful") {
                this.onClose();
                this.$emit("refreshTable");
              }
            })
              .finally(() => {
                this.submitLoading = false;
              })
        }
      }
    },
  },
};
</script>
